import { pluralizationRules } from '~/utils/pluralRules'

export default ({ app }) => {
  app.i18n.pluralizationRules = pluralizationRules
}
